/*!

=========================================================
* Vue Argon Design System - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system/blob/master/LICENSE.md)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
import './registerServiceWorker';
import store from './store/index';
import VueMeta from 'vue-meta';
import requestApi from './resources/request';
import VueI18n from 'vue-i18n';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import { BSpinner } from 'bootstrap-vue'
import Embed from 'v-video-embed'
import Vuelidate from 'vuelidate'

Vue.component('b-spinner', BSpinner)

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(Vuelidate)

Vue.prototype.$api = requestApi;
Vue.use(VueMeta,{
  keyName: 'head',
});
Vue.use(VueI18n);
Vue.config.productionTip = false;
Vue.use(Argon);
Vue.use(Embed);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
